import * as React from "react";

export const Pin: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m.917 15.667 3.642-3.642M2.13 8.412a.83.83 0 0 0 0 1.178l2.432 2.432 2.431 2.431a.83.83 0 0 0 1.179 0l.979-.979a.83.83 0 0 0 .244-.59v-3.28l2.417-2.416 1.924.103a.83.83 0 0 0 .633-.243l.479-.478a.83.83 0 0 0 0-1.178l-3.655-3.655a.83.83 0 0 0-1.179 0l-.478.478a.83.83 0 0 0-.243.633l.103 1.924L6.979 7.19H3.7a.83.83 0 0 0-.59.244zM11.808 7.192 9.392 4.775"
    ></path>
  </svg>
);
